"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserDto = /** @class */ (function () {
    function UserDto() {
    }
    return UserDto;
}());
exports.default = UserDto;
